import { ETruckType, JobHistory } from '../types'

export const tempJobHistoryData: JobHistory[] = [
    {
        id: '1',
        originPoint: 'Cheyenne, WM',
        originAddress: 'Origin Address 1',
        destinationPoint: 'Bangor, MN',
        destinationAddress: 'Destination Address 1',
        distance: '314 mi',
        duration: '2 hours',
        truckType: ETruckType.DUMP_TRUCK,
        rate: '$2.55',
        total: 800,
        loadNumber: 'P21655231',
        shipperName: 'Unum Group LLC',
        shipperAddress: 'Shipper Address 1',
        shipperPhone: '123-456-7890',
        shipperEmail: 'shipper1@example.com',
        shipperChargeAmount: '$50',
        startDate: new Date('2023-09-20T08:00:00'),
        endDate: new Date('2023-09-20T10:00:00'),
        mcNumber: 12345,
        weight: '55,000 lb',
        cargo: 'Sand in bulk',
    },
    {
        id: '2',
        originPoint: 'Concord, IL',
        originAddress: 'Origin Address 2',
        destinationPoint: 'Los Angeles, CA',
        destinationAddress: 'Destination Address 2',
        distance: '120 mi',
        duration: '3 hours',
        truckType: ETruckType.VAN,
        rate: '$2.99',
        total: 1200,
        loadNumber: 'P21655231',
        shipperName: 'Ryder System LTD',
        shipperAddress: 'Shipper Address 2',
        shipperPhone: '234-567-8901',
        shipperEmail: 'shipper2@example.com',
        shipperChargeAmount: '$75',
        startDate: new Date('2023-09-21T09:00:00'),
        endDate: new Date('2023-09-21T12:00:00'),
        mcNumber: 67890,
        weight: '55,000 lb',
        cargo: 'Sand in bulk',
    },
    {
        id: '3',
        originPoint: 'Origin Point 3',
        originAddress: 'Origin Address 3',
        destinationPoint: 'Destination Point 3',
        destinationAddress: 'Destination Address 3',
        distance: '80 mi',
        duration: '1.5 hours',
        truckType: ETruckType.BOX_TRUCK,
        rate: '$250',
        total: 250,
        loadNumber: 'LN789',
        shipperName: 'Shipper 3',
        shipperAddress: 'Shipper Address 3',
        shipperPhone: '345-678-9012',
        shipperEmail: 'shipper3@example.com',
        shipperChargeAmount: '$60',
        startDate: new Date('2023-09-22T10:00:00'),
        endDate: new Date('2023-09-22T11:30:00'),
        mcNumber: 54321,
        weight: '55,000 lb',
        cargo: 'Sand in bulk',
    },
    {
        id: '4',
        originPoint: 'Origin Point 4',
        originAddress: 'Origin Address 4',
        destinationPoint: 'Destination Point 4',
        destinationAddress: 'Destination Address 4',
        distance: '120 mi',
        duration: '2.5 hours',
        truckType: ETruckType.REEFER,
        rate: '$400',
        total: 400,
        loadNumber: 'LN101',
        shipperName: 'Shipper 4',
        shipperAddress: 'Shipper Address 4',
        shipperPhone: '456-789-0123',
        shipperEmail: 'shipper4@example.com',
        shipperChargeAmount: '$90',
        startDate: new Date('2023-09-23T15:00:00'),
        endDate: new Date('2023-09-23T17:30:00'),
        mcNumber: 98765,
        weight: '55,000 lb',
        cargo: 'Sand in bulk',
    },
    {
        id: '5',
        originPoint: 'Orem, UT ',
        originAddress: 'Origin Address 4',
        destinationPoint: 'Greensboro, CL ',
        destinationAddress: 'Destination Address 4',
        distance: '242 mi',
        duration: '2.5 hours',
        truckType: ETruckType.BOX_TRUCK,
        rate: '$3.15',
        total: 710,
        loadNumber: 'P21655231',
        shipperName: 'DCP Midstream',
        shipperAddress: 'Shipper Address 4',
        shipperPhone: '456-789-0123',
        shipperEmail: 'shipper4@example.com',
        shipperChargeAmount: '$90',
        startDate: new Date('2023-09-23T15:00:00'),
        endDate: new Date('2023-09-23T17:30:00'),
        mcNumber: 121151,
        weight: '55,000 lb',
        cargo: 'Sand in bulk',
    },
]

export const usersList = [
    {
        created:
            'Mon Jan 30 2023 04:46:59 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '(643) 926-9757 x7438',
        invitationStatus: 'activated',
        role: 'sub-admin',
    },
    {
        created:
            'Thu May 04 2023 04:32:16 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '861.576.5248',
        invitationStatus: 'pending',
        role: 'admin',
    },
    {
        created:
            'Thu Aug 17 2023 13:46:40 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '1-455-376-5530',
        invitationStatus: 'pending',
        role: 'sub-admin',
    },
    {
        created:
            'Sun Jan 29 2023 22:47:14 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '(772) 536-6079 x5706',
        invitationStatus: 'pending',
        role: 'sub-admin',
    },
    {
        created:
            'Sun Feb 26 2023 22:48:01 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '527-779-1415 x213',
        invitationStatus: 'pending',
        role: 'sub-admin',
    },
    {
        created:
            'Tue Jul 25 2023 10:22:37 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '1-516-737-0004',
        invitationStatus: 'activated',
        role: 'admin',
    },
    {
        created:
            'Thu Mar 09 2023 01:46:27 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '1-665-867-3722',
        invitationStatus: 'pending',
        role: 'sub-admin',
    },
    {
        created:
            'Tue Sep 12 2023 12:10:46 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '1-255-304-3962',
        invitationStatus: 'pending',
        role: 'admin',
    },
    {
        created:
            'Tue Mar 14 2023 17:00:09 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '(317) 878-9771 x68867',
        invitationStatus: 'activated',
        role: 'admin',
    },
    {
        created:
            'Mon Nov 28 2022 11:52:09 GMT+0100 (West Africa Standard Time)',
        email: 'Reina.Hermiston@gmail.com',
        firstName: 'Reina',
        lastName: 'Hermiston',
        id: 1,
        phoneNumber: '636.310.4610',
        invitationStatus: 'activated',
        role: 'admin',
    },
]
